import React from 'react';
import type { SxProps, Theme } from '@mui/material/styles';
import { Box, Paper, Skeleton } from '@mui/material';
import { TableSkeleton } from '../LoadingSkeleton';

interface MaterialCategorySectionsSkeletonProps {
  sections?: number;
  sx?: SxProps<Theme>;
}

const MaterialCategorySectionsSkeleton: React.FC<MaterialCategorySectionsSkeletonProps> = ({
  sections = 2,
  sx,
}) => (
  <Box sx={sx}>
    {Array.from({ length: sections }).map((_, index) => (
      <Paper
        key={index}
        elevation={0}
        sx={{
          borderRadius: '12px',
          overflow: 'hidden',
          border: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Box
          sx={{
            px: 2,
            py: 1.5,
            display: 'flex',
            alignItems: 'center',
            gap: 1.25,
            borderBottom: '1px solid',
            borderColor: 'divider',
          }}
        >
          <Skeleton variant="rounded" width={36} height={36} sx={{ borderRadius: 1.25 }} />
          <Skeleton variant="text" width={140} height={24} />
        </Box>
        <TableSkeleton rows={3} columns={3} elevated={false} />
      </Paper>
    ))}
  </Box>
);

export default MaterialCategorySectionsSkeleton;
